<template>
  <div class="w-full h-full bg-surface-50 dark:bg-surface-950 overflow-hidden">
    <div
      v-if="resultKey === 0 || plotLoading"
      class="w-full h-full flex items-center justify-center"
    >
      <SkeletonChart :loading="plotLoading" class="w-60 h-60" />
    </div>

    <iframe
      v-else
      :key="resultKey"
      class="w-full h-full border-none"
      :src="iframeHtml"
    />
  </div>
</template>

<script setup>
import SkeletonChart from "@/components/SkeletonChart.vue";
import { defineProps } from "vue";

defineProps({
  resultKey: { type: Number, default: 0 },
  plotLoading: { type: Boolean, default: false },
  iframeHtml: { type: String, default: "" },
});
</script>
